// Single source of the merchant-order charge currency, shared by create-order (quote shown
// to the buyer) and create-order-checkout (amount sent to Stripe) so both always agree.
export const ORDER_CURRENCIES = new Set(["eur", "usd", "cad", "gbp"]);

/** Lowercase ISO code charged for a store's orders, or null when unsupported. */
export function resolveOrderCurrency(defaultCurrency: string | null | undefined): string | null {
  const c = (defaultCurrency ?? "EUR").toLowerCase();
  return ORDER_CURRENCIES.has(c) ? c : null;
}
